import React from 'react';
import PropTypes from 'prop-types';

import catHombres from '../../assets/images/new/CAT HOMBRES.svg';
import catMujeres from '../../assets/images/new/CAT MUJERES.svg';
import catMixto from '../../assets/images/new/CAT MIXTO.svg';
import proCyclistIcon from '../../assets/images/new/CICLISTA PRO.svg';

import { Row, Col } from 'react-flexbox-grid';

const TableRankingIndividualItem = ({
  userInfo,
  calendar,
  firstRaking,
  darkMode,
  individualFavorites,
  saveFavorite,
  deleteFavorite,
  selectedSegmentFilter,
  individualSegment,
  favoritesEnabled,
}) => {
  const participant = calendar ? userInfo.participant : userInfo;

  const normalizeGenderCategory = (value) => {
    const gender = String(value || '').toUpperCase();
    if (gender === 'MEN' || gender === 'MALE' || gender === 'M') return 'MEN';
    if (
      gender === 'WOMEN' ||
      gender === 'FEMALE' ||
      gender === 'F' ||
      gender === 'MUJERES'
    ) {
      return 'WOMEN';
    }
    return 'MIXED';
  };

  const getCategoryIcon = (gender) => {
    if (gender === 'MEN') return catHombres;
    if (gender === 'WOMEN') return catMujeres;
    return catMixto;
  };

  const getCategoryLabel = (gender) => {
    if (gender === 'MEN') return 'HOMBRES';
    if (gender === 'WOMEN') return 'MUJERES';
    return 'MIXTO';
  };

  const isProParticipant = () => {
    const category = String(participant?.category || '').toUpperCase();
    return category.includes('PRO');
  };

  const photoUrl = calendar ? participant.photoUrl : participant.photo_url;
  const fallbackGender = normalizeGenderCategory(
    participant?.team?.gender || participant?.gender
  );

  const addButtonText = () => {
    if (!favoritesEnabled) return null;
    let buttonText = '+';
    let saveFunction = saveFavorite;
    let favoriteId = participant.userId || participant.user_id;
    if (individualFavorites) {
      individualFavorites.forEach((individualFavorite) => {
        if (individualFavorite.favoriteId === participant.userId) {
          buttonText = '-';
          favoriteId = individualFavorite.favoriteId;
          saveFunction = deleteFavorite;
        }
      });
    }
    return (
      <div
        onClick={() => {
          saveFunction(favoriteId);
        }}
        className='add-button'
      >
        {buttonText}
      </div>
    );
  };

  const showTime = (timeDate, status, note) => {
    const formatCalendarTime12h = (dateValue) => {
      const parsedDate = new Date(dateValue);
      if (Number.isNaN(parsedDate.getTime())) return '--:--:--';
      const hours24 = parsedDate.getUTCHours();
      const hours12 = hours24 % 12 || 12;
      const mm = String(parsedDate.getUTCMinutes()).padStart(2, '0');
      const ss = String(parsedDate.getUTCSeconds()).padStart(2, '0');
      return `${hours12}:${mm}:${ss}`;
    };

    // En calendario recibimos un datetime (startTime), no segundos.
    // Salimos temprano para evitar parseos numéricos inválidos.
    if (calendar) {
      if (!timeDate) return <div>--:--:--</div>;
      return <div>{formatCalendarTime12h(timeDate)}</div>;
    }

    const dnf = status === 2;
    const dq = status === 3;
    const waitingStatus = status === 1;
    const elapsed = Number(timeDate || 0);

    const validTime = !dnf && !dq && !waitingStatus && elapsed > 0;

    const waiting = !dnf && !dq && !validTime;
    return (
      <div>
        {dnf && 'DNF'}
        {dq && 'DQ'}
        {waiting && 'Esperando tiempo'}
        {validTime && new Date(elapsed * 1000).toISOString().substr(11, 8)}
        {validTime && firstRaking.id !== userInfo.id && (
          <div className='table-ranking-item_user-info-team'>
            {firstRaking.id !== userInfo.id && <span>{'+ '}</span>}
            {firstRaking.id === userInfo.id
              ? `${new Date(elapsed * 1000).toISOString().substr(11, 8)}`
              : `${new Date(
                  Math.abs(elapsed - Number(firstRaking['elapsed_time'] || 0)) *
                    1000
                )
                  .toISOString()
                  .substr(11, 8)}`}
          </div>
        )}
        {note !== '' && <div className='note-text'>{note}</div>}
      </div>
    );
  };
  return (
    <Col xs={12} className={`table-ranking-item${darkMode ? ' darkMode' : ''}`}>
      <Row className='table-ranking-item_column-container'>
        <Col xs={12}>
          <Row className='table-ranking-item_column-container_main individual'>
            <Col xs={3} className='table-ranking-item_column'>
              {addButtonText()}
              <div className='position-text'>{userInfo.ranking}</div>
            </Col>
            <Col
              xs={5}
              className='table-ranking-item_column individual-main-column'
            >
              <div className='table-ranking-item_user-img-container'>
                <div
                  className={`fallback-avatar fallback-avatar-${fallbackGender.toLowerCase()}`}
                  title={getCategoryLabel(fallbackGender)}
                >
                  <img
                    src={getCategoryIcon(fallbackGender)}
                    alt={getCategoryLabel(fallbackGender)}
                    className='fallback-avatar-icon'
                  />
                </div>
                {photoUrl && (
                  <img
                    src={photoUrl}
                    alt='user'
                    className='table-ranking-item_user-img'
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                    }}
                  />
                )}
              </div>
              <div className='table-ranking-item_user-info-container'>
                <div className='table-ranking-item_user-info-name'>
                  <span className='name-text'>
                    {`${participant.name} ${
                      calendar ? participant.lastName : participant.last_name
                    }`}
                  </span>
                  {isProParticipant() && (
                    <img
                      src={proCyclistIcon}
                      alt='pro'
                      className='pro-cyclist-icon'
                    />
                  )}
                </div>
                <div className='table-ranking-item_user-info-team'>
                  <span>{participant.team ? participant.team.name : 'Individual'}</span>
                </div>
              </div>
            </Col>
            {/* <Col xs={2} className='table-ranking-item_column'>
              {renderCategory(
                userInfo.athlete.ageCategory,
                userInfo.team.genderCategory
              )}
            </Col> */}
            <Col xs={4} className='table-ranking-item_column'>
              <div className='table-ranking-item_category'>
                {showTime(
                  calendar ? userInfo.startTime : userInfo['elapsed_time'],
                  calendar ? 0 : userInfo.race_status,
                  calendar ? '' : userInfo.note
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

TableRankingIndividualItem.propTypes = {
  saveFavorite: PropTypes.func.isRequired,
  deleteFavorite: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  firstRaking: PropTypes.object.isRequired,
  calendar: PropTypes.bool,
  darkMode: PropTypes.bool,
  individualFavorites: PropTypes.array.isRequired,
  selectedSegmentFilter: PropTypes.string,
  individualSegment: PropTypes.string,
  favoritesEnabled: PropTypes.bool,
};

TableRankingIndividualItem.defaultProps = {
  calendar: false,
  darkMode: false,
  selectedSegmentFilter: null,
  individualSegment: null,
  favoritesEnabled: false,
};

export default TableRankingIndividualItem;
